import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Stepper, Step, StepLabel, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import SaveIcon from '@material-ui/icons/Save'
import { Page, Header, CustomButton } from 'components'
import useRouter from 'utils/useRouter'
import { FormDadosCaracteristicos } from './FormDadosCaracteristicos'
import { FormTatuagensECicatrizes } from '../ExameNecroscopico/FormTatuagensECicatrizes'
import { FormMapaOdontologico } from './FormMapaOdontologico'
import { useExameNecrodontoscopico } from './hooks/useExameNecrodontoscopico'
import { useStyles } from './ExameNecrodontoscopico.styles'

const steps = ['Dados característicos', 'Sinais Particulares da Face', 'Odontograma']

export const ExameNecrodontoscopico = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()

  const {
    exameNecrodontoscopico,
    processandoOperacao,
    processandoDados,
    formData,
    formMarcas,
    formSVG,
    formDentes,
    activeStep,
    setFormMarcas,
    setFormSVG,
    setFormDentes,
    setProcessandoDados,
    setEditarDentes,
    handleChange,
    handleChangeComArredondamento,
    handleNext,
    handleBack,
  } = useExameNecrodontoscopico()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header
        titulo={`Exame ${exameNecrodontoscopico?.exReal?.numeroExame || ''}`}
        overline={route.secao}
      />
      
      <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div className={classes.stepContainer}>
        {activeStep === 0 && (
          <FormDadosCaracteristicos
            formData={formData}
            route={route}
            handleChange={handleChange}
            handleChangeComArredondamento={handleChangeComArredondamento}
          />
        )}

        {activeStep === 1 && exameNecrodontoscopico?.exReal && (
          <FormTatuagensECicatrizes
            idExameRealizado={exameNecrodontoscopico.exReal.id}
            idCadaver={exameNecrodontoscopico.exReal.exSol?.cadavs?.[0]?.id}
            setCicatrizesForm={setFormMarcas}
            setSVGTatuagensForm={setFormSVG}
            odonto
          />
        )}

        {activeStep === 2 && exameNecrodontoscopico && (
          <FormMapaOdontologico
            idExameNecrodontoscopico={exameNecrodontoscopico.id}
            setProcessandoDados={setProcessandoDados}
            dentes={formDentes}
            setDentes={setFormDentes}
            setEditar={setEditarDentes}
          />
        )}
      </div>

      <Divider className={classes.divider} />

      <Grid container justifyContent="space-between" spacing={1} className={classes.navigationContainer}>
        <Grid item>
          {activeStep === 0 ? (
            <CustomButton
              variant="outlined"
              onClick={() => router.history.goBack()}
              startIcon={<ArrowBackIcon />}
            >
              Voltar
            </CustomButton>
          ) : (
            <CustomButton
              variant="outlined"
              onClick={handleBack}
              startIcon={<NavigateBeforeIcon />}
            >
              Etapa Anterior
            </CustomButton>
          )}
        </Grid>
        <Grid item>
          <CustomButton
            variant="contained"
            colorType="primary"
            onClick={handleNext}
            disabled={processandoDados}
            isLoading={processandoOperacao}
            className={classes.buttonProgress}
            startIcon={activeStep === steps.length - 1 ? <SaveIcon /> : <NavigateNextIcon />}
          >
            {activeStep === steps.length - 1 ? 'Finalizar formulário' : 'Próxima Etapa'}
          </CustomButton>
        </Grid>
      </Grid>
    </Page>
  )
}

ExameNecrodontoscopico.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string.isRequired,
  }).isRequired,
}
